export default __webpack_public_path__ + "static/color-role-do-light-1590199000af4f6868b4cf1a3a641f17f39ede5362703e4ca451880ed3dc74f1.png";